<template>
    <section class="cart">
        <div class="custom-container">
            <div class="row">
                <div class="col-12">
                    <div class="cart__inner" :class="{loading: loading}">
                        <template v-if="loaded">
                            <template v-if="items.length">
                                <div class="cart__tab-wrapper">
                                    <div class="tab-content cart__tab-content" id="cart-tabContent">
                                        <div class="tab-pane cart__tab-pane fade show active" id="cart-shopping-basket">
                                            <div class="cart__item" v-for="item in items">
                                                <div class="cart__item__main">
                                                    <div class="cart__item__header">
                                                        <img
                                                            v-if="!!item.product.gallery[0]"
                                                            :src="item.product.gallery[0].thumb_url"
                                                            class="cart__item__img"
                                                            :alt="item.product.title"
                                                        />
                                                        <img
                                                            class="cart__item__img"
                                                            v-else src="/images/placeholder.png"
                                                            alt="item.product.title"
                                                        >
                                                    </div>
                                                    <div class="cart__item__content">
                                                        <h3 class="cart__item__title">
                                                            {{item.product.title}}
                                                        </h3>
                                                        <div class="cart__item__body">
                                                            <div class="cart__item__properties">
                                                                <div v-if="item.product.color_hex" class="cart__item__properties__color">
                                                            <span
                                                                class="bullet"
                                                                :style="`background-color: ${item.product.color_hex ? item.product.color_hex : '#ffffff'}`"
                                                            ></span>
                                                                    {{item.product.color_name}}
                                                                </div>
                                                                <div v-if="item.product.guarantee" class="cart__item__properties__text-item">
                                                                    <span class="icon-Bookmark"></span>
                                                                    {{item.product.guarantee}}
                                                                </div>
                                                            </div>
                                                            <div class="cart__item__actions">
                                                                <button class="btn cart__item__delete-btn" @click="remove(item.product_stock_id)">
                                                                    <span class="icon-Trash"></span>حذف
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="cart__item__footer">
                                                    <div class="cart__item__counter">
                                                        <button class="cart__item__counter__increaser icon-Plus" :disabled="item.max_quantity <= item.quantity" @click="update(item.product_stock_id, item.quantity+1, item)"></button>
                                                        <span class="cart__item__counter__count">{{item.quantity}}</span>
                                                        <button class="cart__item__counter__decreaser icon-Minus" :disabled="item.quantity === 1" @click="update(item.product_stock_id, item.quantity-1, item)"></button>
                                                    </div>
                                                    <div class="cart__item__price">{{numberFormat(item.final_price)}} <span class="cart__item__price__monetary-unit">تومان</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="price-info">
                                    <div class="price-info__inner">
                                        <div class="price__info__item">
                                            <span class="price__info__item__key">قیمت کالاها ({{items.length}}) :</span>
                                            <div class="price__info__item__value">
                                                {{numberFormat(totals.subtotal)}}
                                                <span class="price__info__item__monetary-unit">تومان</span>
                                            </div>
                                        </div>
                                        <div class="price__info__item price__info__item--off">
                                            <span class="price__info__item__key">تخفیف :</span>
                                            <div class="price__info__item__value">
                                                ({{totals.discount_percentage}}%){{numberFormat(totals.discount)}}
                                                <span class="price__info__item__monetary-unit">تومان</span>
                                            </div>
                                        </div>
                                        <div class="price__info__item price__info__item--final">
                                            <span class="price__info__item__key">جمع قیمت محصولات: </span>
                                            <div class="price__info__item__value">
                                                {{numberFormat(totals.total)}} <span class="price__info__item__monetary-unit">تومان</span>
                                            </div>
                                        </div>
                                        <p class="price__info__text">
                                            هزینه‌ی ارسال در ادامه بر اساس آدرس، زمان و نحوه‌ی ارسال
                                            انتخابی شما‌ محاسبه و به این مبلغ اضافه خواهد شد.
                                        </p>
                                        <div class="price-info__btn-wrapper">
                                            <a :href="route('checkout')" class="btn custom-btn custom-btn--primary price-info__btn">ادامه فرایند</a>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="loaded">
                                <div class="text-center d-block" style="width: 100%">
                                    <div class="alert alert-info mb-3">کالایی در سبد خرید شما موجود نیست.</div>
                                    <a href="/" class="btn btn-success">بازگشت به صفحه اصلی</a>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {DataTableMixin} from "../../../admin/components/general/DataTableMixin";

export default {
    name: "Cart",
    mixins: [DataTableMixin],
    data() {
        return {
            loading: true,
            loaded: false
        }
    },
    computed: {
        items() {
            return this.response.data;
        },
        totals() {
            return this.response.totals ? this.response.totals : {};
        },
        _requestUrl() {
            return this.route('api.cart.list');
        },
    },
    methods: {
        remove(id) {
            this.$swal({
                title: 'آیا مطمئن هستید؟',
                text: "آیا می خواهید این محصول را از سبد خرید حذف کنید؟",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loading = true;
                    const token = localStorage.getItem('_token');
                    let config = {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    };
                    this.axios.delete(this.route('api.cart.destroy', id), config).then(response => {
                        this.loading = false;
                        this.response = response.data;
                        this.$store.commit('cart/init', response.data);
                    });
                }
            });
        },
        update(id, value, item) {
            if (value < 1 || value > item.max_quantity) {
                return;
            }
            this.loading = true;
            const token = localStorage.getItem('_token');
            let config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            this.axios.put(this.route('api.cart.quantity', [id, value]), null, config).then(response => {
                this.loading = false;
                this.response = response.data;
                this.$store.commit('cart/init', response.data);
            });
        },
        onSuccessful() {
            this.loaded = true;
        }
    }
}
</script>

<style scoped>

</style>
